/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/no-danger */
import PropTypes from 'prop-types';
import cn from 'classnames';
import { BiMinus, BiPlus } from 'react-icons/bi';
import { useState, useRef, useEffect } from 'react';
import styles from './accordion.module.scss';
import Title from '@/components/molecules/Title';

const Accordion = ({
  title = '',
  noHide = '',
  description = '',
  selected = false,
  onchange = () => {},
  descriptionStyles = {}
}) => {
  const [open, setOpen] = useState(selected);

  const infoRef = useRef(null);
  const verticalRef = useRef(null);
  const horizontalRef = useRef(null);
  const accordionClasses = cn({
    [styles.description]: true,
    [styles.box]: true
  });

  const noHideClasses = cn({
    [styles.description]: true
  });

  const openAccordion = () => {
    if (infoRef.current) {
      infoRef.current.style.height = `${infoRef.current.scrollHeight}px`;
    }
    if (verticalRef.current) {
      verticalRef.current.style.transform = 'rotate(360deg)';
    }
    if (horizontalRef.current) {
      horizontalRef.current.style.opacity = '0';
      horizontalRef.current.style.transform = 'rotate(360deg)';
    }
    onchange(infoRef.current.scrollHeight);
  };
  const openInfo = () => {
    if (!open) {
      openAccordion();
    } else {
      verticalRef.current.style.transform = 'rotate(0deg)';
      horizontalRef.current.style.opacity = '1';
      horizontalRef.current.style.transform = 'rotate(0deg)';
      infoRef.current.style.height = '0px';

      onchange(-infoRef.current.scrollHeight);
    }
  };
  const handleClickAccordion = () => {
    openInfo();
    setOpen(!open);
  };
  useEffect(() => {
    if (selected) openAccordion(true);
  }, []);

  return (
    <div className={styles.container}>
      <div className={styles.titleSection}>
        <div
          className={styles.title}
          onClick={() => handleClickAccordion()}
        >
          <Title
            label={title}
            iconEnd
            icon={
              <div className={styles.icon}>
                <div
                  ref={verticalRef}
                  className={styles.vertical}
                >
                  <BiMinus fontSize={15} />
                </div>
                <div
                  ref={horizontalRef}
                  className={styles.horizontal}
                >
                  <BiPlus fontSize={15} />
                </div>
              </div>
            }
          />
        </div>
      </div>
      {noHide && <div className={noHideClasses}>{noHide}</div>}
      <div
        ref={infoRef}
        className={accordionClasses}
        style={descriptionStyles}
      >
        {description}
      </div>
    </div>
  );
};

Accordion.propTypes = {
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  noHide: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  title: PropTypes.string,
  selected: PropTypes.bool,
  onchange: PropTypes.func,
  descriptionStyles: PropTypes.object
};

export default Accordion;
